import dayjs from 'dayjs';
import { RecentSearch } from 'storage/recentSearches/common';
import { ProviderFacetGroups } from 'store/findProvider/types';
import { ProviderSearchOptions, ProviderSearchSuggestion } from 'store/providerSearch/types';
import { oc } from 'ts-optchain';

//
//  Function: sortByDate
//  Description: Sorts quick links by date
//
export function sortByDate(a: RecentSearch, b: RecentSearch): number {
  const at = dayjs(a.date);
  const bt = dayjs(b.date);
  if (at.isBefore(bt)) return 1;
  if (at.isAfter(bt)) return -1;
  return 0;
}

export const updateFacetsOnSpecialtySelect = (
  options: ProviderSearchOptions,
  option: ProviderSearchSuggestion
) => {
  if (
    oc(option)
      .category('')
      .toLowerCase() === ProviderFacetGroups.specialty
  ) {
    const facets = oc(options).facets([]);
    facets.push({
      group: ProviderFacetGroups.specialty,
      title: oc(option).value(''),
      value: oc(option).value('')
    });
    options = { ...options, facets };
  }

  return options;
};

export const sortAlphabeticDescending = (arr: []) => {
  return arr.slice().sort((a, b) => (a.value < b.value ? -1 : a.value > b.value ? 1 : 0));
};
